var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelicopter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.33,92.39s-4.59,52.15,45.23,34.86M48.68,93A15.21,15.21,0,1,1,33.48,77.7,15.23,15.23,0,0,1,48.68,93Zm76.17,62.91H187l6.36-5M80.68,78.64H189.5M174,155.15V143.48m-36,11.67V143.48M134.74,92.1V80.77m-34,11.78H33.88L100.7,111m.47-18.54v20.46s1.91,27.22,28.09,30.56h49.29s27.91,1.77,6-16.23c0,0,1.85-32.47-38.63-34.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/HELICOPTER.515f1db4517b3f2e692676b428db0ef7.svg";
export { ForwardRef as ReactComponent };